import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CTABanner = () => {
  return (
    <section className="py-0">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-gradient-to-r from-gold via-gold to-gold-light"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            {/* Left - Message */}
            <h2 className="font-serif text-3xl lg:text-4xl font-bold text-primary-dark text-center lg:text-left">
              Bugün Kendin İçin Bir Adım At
            </h2>

            {/* Right - CTA Buttons */}
            <div className="flex items-center space-x-4">
              <Link
                to="/randevu"
                className="px-8 py-4 bg-primary-dark text-white font-semibold rounded-full hover:scale-105 hover:shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Ücretsiz Ön Görüşme
              </Link>
              
              <a
                href="https://wa.me/905366460317"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center text-white hover:scale-110 transition-all duration-300 cursor-pointer"
                style={{ animation: 'pulse 2s infinite' }}
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
              </a>
            </div>
          </div>
        </div>
      </motion.div>

      <style>{`
        @keyframes pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
          50% { box-shadow: 0 0 0 10px rgba(37, 211, 102, 0); }
        }
      `}</style>
    </section>
  );
};

export default CTABanner;